/**
 * Galerie swipe cartes collection : pastilles (IntersectionObserver) + tap pour fiche produit.
 */
(function () {
  let resizeTimer;
  let resizeListenerAttached = false;

  const TAP_MAX_MOVE = 14;
  const TAP_MAX_TRACK_SCROLL = 22;
  const TAP_MAX_PAGE_SCROLL = 12;
  const TAP_MAX_MS = 550;

  /** Part horizontale de la slide visible dans la piste (0–1). */
  function horizontalVisibility(slide, track) {
    const sr = slide.getBoundingClientRect();
    const tr = track.getBoundingClientRect();
    const overlap = Math.min(sr.right, tr.right) - Math.max(sr.left, tr.left);
    if (overlap <= 0 || sr.width <= 0) return 0;
    return overlap / sr.width;
  }

  function syncDots(track) {
    const slides = track.querySelectorAll('.card__media-track-slide');
    if (!slides.length) return;

    const cardRoot = track.closest('.product-card-wrapper') || track.closest('.card-wrapper');
    let dots = cardRoot?.querySelectorAll('.card__media-toolbar .card__media-dot');
    if (!dots || !dots.length) {
      const panel = track.closest('.card__media-panel--mobile');
      dots = panel?.querySelectorAll('.card__media-dot');
    }
    if (!dots || !dots.length) return;

    let bestIdx = 0;
    let best = -1;
    slides.forEach((slide, idx) => {
      const v = horizontalVisibility(slide, track);
      if (v > best) {
        best = v;
        bestIdx = idx;
      }
    });

    dots.forEach((dot, j) => dot.classList.toggle('is-active', j === bestIdx));
  }

  function syncAllTracks() {
    document
      .querySelectorAll('.card__media--has-swipe .card__media-track[data-gallery-dots-bound="1"]')
      .forEach(syncDots);
  }

  function ensureGlobalResize() {
    if (resizeListenerAttached) return;
    resizeListenerAttached = true;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncAllTracks, 200);
      },
      { passive: true }
    );
  }

  function bindTrack(track) {
    if (track.dataset.galleryDotsBound === '1') return;
    track.dataset.galleryDotsBound = '1';

    const slides = track.querySelectorAll('.card__media-track-slide');
    if (!slides.length) return;

    let raf = 0;
    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        syncDots(track);
      });
    };

    const observer = new IntersectionObserver(schedule, {
      root: track,
      rootMargin: '0px',
      threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
    });

    slides.forEach((slide) => observer.observe(slide));

    ensureGlobalResize();
    schedule();
  }

  function bindProductTap(panel) {
    if (panel.dataset.galleryTapBound === '1') return;
    panel.dataset.galleryTapBound = '1';

    const url = panel.getAttribute('data-product-url');
    if (!url) return;

    const track = panel.querySelector('.card__media-track');
    if (!track) return;

    let downX;
    let downY;
    let downScroll;
    let downWinY;
    let downTime;
    let downPid;

    function maybeNavigate() {
      window.location.href = url;
    }

    track.addEventListener(
      'pointerdown',
      (e) => {
        if (e.button !== 0 || !e.isPrimary) return;
        downPid = e.pointerId;
        downX = e.clientX;
        downY = e.clientY;
        downScroll = track.scrollLeft;
        downWinY = window.scrollY;
        downTime = Date.now();
      },
      { passive: true }
    );

    track.addEventListener(
      'pointerup',
      (e) => {
        if (e.button !== 0 || !e.isPrimary || e.pointerId !== downPid) return;
        const dx = e.clientX - downX;
        const dy = e.clientY - downY;
        const dScroll = Math.abs(track.scrollLeft - downScroll);
        const dWin = Math.abs(window.scrollY - downWinY);
        const dt = Date.now() - downTime;

        if (
          Math.abs(dx) < TAP_MAX_MOVE &&
          Math.abs(dy) < TAP_MAX_MOVE &&
          dScroll < TAP_MAX_TRACK_SCROLL &&
          dWin < TAP_MAX_PAGE_SCROLL &&
          dt < TAP_MAX_MS
        ) {
          maybeNavigate();
        }
      },
      { passive: true }
    );

    panel.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        maybeNavigate();
      }
    });
  }

  function init(root) {
    const r = root || document;
    r.querySelectorAll('.card__media--has-swipe .card__media-track').forEach(bindTrack);
    r.querySelectorAll('.card__media-panel--mobile[data-product-url]').forEach(bindProductTap);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
